import '../../../styles/trangchu.scss';
import React, { useEffect, useState } from 'react';
import image_list from '../../../assets/images/List_Up_Minimalistic.png';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

export default function BieuDoCot({ dataThongKe }) {
    const [data, setData] = useState([]);
    useEffect(() => {
        if (dataThongKe) setData(dataThongKe.tongTienNopPhi_TheoDonVi_BieuDoCot ? dataThongKe?.tongTienNopPhi_TheoDonVi_BieuDoCot : []);
    }, [dataThongKe]);

    const RenderLegend = (props) => {
        const { payload } = props;
        return (
            <div style={{ display: 'flex', justifyContent: 'end' }}>
                {payload.map((entry, index) => (
                    <div style={{ display: 'flex', marginLeft: 50 }}>
                        <div
                            style={{
                                width: 20,
                                height: 8,
                                borderRadius: 10,
                                marginTop: 3,
                                marginRight: 5,
                                background: entry.color,
                            }}
                        ></div>
                        <div className="bieudocot-legend-label">Tổng tiền</div>
                    </div>
                ))}
            </div>
        );
    };
    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            return (
                <div style={{ background: '#000000ba', borderRadius: 5, padding: 10, color: '#fff' }}>
                    <div>{`Tổng tiền ${label}`}</div>
                    <div>{`Năm: ${currencyFormatter(payload[0].value)}`}</div>
                </div>
            );
        }
    
        return null;
    };
    const currencyFormatter = (value) => {
        return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(value);
    };
    return (
        <div className="thongke-main thongke-main-bieudo" style={{ height: 400 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 10px 10px 15px' }}>
                <div className="bieudocot-label">TỔNG TIỀN THU THEO ĐƠN VỊ</div>
                <div style={{ display: 'flex' }}>
                    <div className="bieudocot-nam">Năm nay</div>
                    <img src={image_list} style={{ filter: 'opacity(0.5) drop-shadow(0 0 0 red)' }} />
                </div>
            </div>
            <div style={{ height: 300 }}>
                <ResponsiveContainer>
                    <BarChart
                        data={data}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 70,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <XAxis dataKey="name" axisLine={false} tickLine={false} />
                        <YAxis tickFormatter={currencyFormatter} />
                        <Tooltip content={<CustomTooltip />} />
                        <Legend verticalAlign="bottom" align="right" content={<RenderLegend />} />
                        <Bar dataKey="uv" fill="#ba6537" barSize={6} radius={[10, 10, 0, 0]} />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}
